module.exports = __webpack_public_path__ + "img/plan-3-5.08bcea4f.png";